import moment from 'moment';

export default function formatDate(date: moment.MomentInput, format: string): string | null {
  const m = moment(date);
  if (!m.isValid()) {
    return null;
  }
  return m.format(format);
}
